<script>

export default {
    props: {
        filter: {
            required: true
        },
        url: {
            required: true
        }
    },
    data: function(){
        return {
            currentFilter: this.filter
        }
    },
    methods: {
        setFilter(filter){
            this.currentFilter = filter;
            window.location = this.url+"?filter="+this.currentFilter;
        }
    }
}
</script>